import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable, Subscriber } from 'rxjs';
import 'rxjs/add/operator/map';
import { HttpClientService } from '../http-client/http-client.service';
import { CourseYear } from '../../models/course-years/course-year';

@Injectable()
export class CourseYearService {

    public courseYears: CourseYear[];
    public courseYearsObject: any;

    constructor(private http: HttpClientService) {
        this.courseYears = [];
        this.courseYearsObject = {};
    }

    public getAll(): Observable<CourseYear[]> {
        if (!!this.courseYears && this.courseYears.length > 0) {
            return Observable.create((observer: Subscriber<CourseYear[]>) => {
                observer.next(this.courseYears);
                observer.complete();
            });
        }
        const url = 'courseyear/all';
        return this.http.get(url).map(response => {
            let r = response.json();
            if (r.ResultCode === 1) {
                this.courseYears = r.Result;
                this.courseYearsObject = this.courseYears.reduce((result, st) => {
                    result[String(st.Id)] = result[String(st.Id)] || {};
                    result[String(st.Id)] = st;
                    return result;
                }, {});
            } else {
                console.error('courseYearsService > getAll > response', r);
            }
            return this.courseYears;
        }).catch(this.handleError);
    }

    /*public getById(id: number): Observable<StoreType> {
        if (!!this.storeTypes && this.storeTypes.length > 0 && !!this.storeTypes.find(st => st.id == id)) {
            return Observable.create((observer: Subscriber<StoreType>) => {
                observer.next(this.storeTypes.find(st => st.id == id));
                observer.complete();
            });
        }
        const url = 'store-types/id/' + id;
        return this.http.get(url).map(response => {
            let r = response.json();
            let storeType = null;
            if (r.resultCode === 1) {
                storeType = r.result;
                let alreadyExist = this.storeTypes.find(st => st.id == storeType.id);
                if (!alreadyExist) {
                    this.storeTypes.push(storeType);
                    this.storeTypesObject[storeType.id] = storeType;
                }
            } else {
                console.error('StoreTypeService > getById > response', r);
            }
            return storeType;
        }).catch(this.handleError);
    }

    public add(name: string, description: string) {
        const url = 'store-types/add';
        return this.http.post(url, {
            Name: name,
            Description: description
        }).map(response => response.json())
        .catch(this.handleError);
    }

    public edit(id: number, name: string, description: string) {
        const url = 'store-types/edit';
        return this.http.put(url, {
            Id: id,
            Name: name,
            Description: description
        }).map(response => response.json())
        .catch(this.handleError);
    }

    public delete(id: number) {
        const url: string = 'store-types/delete/' + id;
        return this.http.delete(url).map(response => response.json())
            .catch(this.handleError);
    }*/

    public handleError(error: Response) {
        // console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }

}



// WEBPACK FOOTER //
// ./src/app/main/services/cour-years/course-year.service.ts